export default __webpack_public_path__ + "assets/fonts/Rubik-Bold.ttf";